module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: [_vm.colClass, _vm.classError]
  }, [_c('label', {
    staticClass: "form-label",
    class: {
      'bold': _vm.required || _vm.bold
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), (_vm.required) ? _c('span', {
    staticClass: "t-error"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.error.message !== null && _vm.error !== false) ? _c('span', {
    staticClass: "t-error dsblock"
  }, [_vm._v("\n      " + _vm._s(_vm.getErrorMessage()) + "\n    ")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4252570","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/FormGroup.vue
// module id = 3492
// module chunks = 0